export default "<div class=\"pacman\" style=\"display: inline-block;\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>";